import { useI18nStore } from '@/stores/i18n-store';
import { translations, type Locale } from './translations';

type Strings = (typeof translations)[Locale];

export const useI18n = () => {
  const locale = useI18nStore((state) => state.locale);
  const setLocale = useI18nStore((state) => state.setLocale);

  const strings: Strings = translations[locale];

  return {
    locale,
    setLocale,
    strings,
  };
};
